'use strict';

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {ScrollToPlugin} from "gsap/ScrollToPlugin.js";

const init = () => {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    const urlHash = window.location.href.split("#")[1];

    if (urlHash && urlHash.indexOf('#&gid=') === -1 && urlHash.indexOf('&pid=') === -1) {
        const element = document.getElementById(urlHash);
        if (element) {
            let y = element.getBoundingClientRect().top + window.scrollY;
            const header = document.getElementById('main-header');

            if (header) {
                const headerStyles = window.getComputedStyle(header);

                if (headerStyles.position === 'fixed') {
                    y -= header.offsetHeight;
                }
            }

            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }
}

export default {init}
